import { render, staticRenderFns } from "./ProductItem2.vue?vue&type=template&id=7df28130&"
import script from "./ProductItem2.vue?vue&type=script&lang=js&"
export * from "./ProductItem2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports